import { type PropsWithChildren, useLayoutEffect, useState } from 'react';

import { ConfigProvider, type ConfigProviderProps } from 'antd';
import enUS from 'antd/locale/en_US';
import itIT from 'antd/locale/it_IT';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

import { LANGUAGE } from '@/shared/constants/language';
import { useLanguage } from '@/shared/lib/hooks';

import { THEME_CONFIG } from '../config/theme-config';

interface ThemeProviderProps extends PropsWithChildren {}

export function AntConfigProvider(props: ThemeProviderProps) {
    const { children } = props;

    const [locale, setLocale] =
        useState<Required<ConfigProviderProps>['locale']>(enUS);

    const [currentLanguage] = useLanguage();

    useLayoutEffect(() => {
        switch (currentLanguage) {
            case LANGUAGE.english:
                setLocale(enUS);
                dayjs.locale('en');

                break;
            case LANGUAGE.italian:
                setLocale(itIT);
                dayjs.locale('it');

                break;
            default:
                break;
        }
    }, [currentLanguage]);

    return (
        <ConfigProvider
            locale={locale}
            prefixCls="algotech"
            theme={THEME_CONFIG}
        >
            {children}
        </ConfigProvider>
    );
}
